import AtomDateRangePicker from '@/components/Atoms/AtomDateRangePicker/AtomDateRangePicker'
import AtomSearchInput from '@/components/Atoms/AtomSearchInput/AtomSearchInput'
import AtomSelect from '@/components/Atoms/AtomSelect/AtomSelect'
import HoverElement from '@/components/Atoms/HoverElement/HoverElement'

import {
  isUsersEnabledFilter,
  USERS_ENABLED_OPTIONS,
} from '../lib/usersListParams'
import type { UsersFilters as UsersFiltersValue } from '../types/users.types'
import cn from './UsersFilters.module.scss'

type UsersFiltersProps = {
  value: UsersFiltersValue
  onChange: (value: UsersFiltersValue) => void
  isOrganisationSelected: boolean
}

function UsersFilters({
  value,
  onChange,
  isOrganisationSelected,
}: UsersFiltersProps) {
  return (
    <div className={cn.filters}>
      <AtomSearchInput
        className={cn.search}
        placeholder="Поиск по ФИО"
        aria-label="Поиск по ФИО"
        value={value.description}
        onChange={(event) =>
          onChange({ ...value, description: event.target.value })
        }
        isOrganisationSelected={isOrganisationSelected}
      />
      <AtomSearchInput
        className={cn.search}
        placeholder="Поиск по логину"
        aria-label="Поиск по логину"
        inputMode="numeric"
        value={value.login}
        onChange={(event) => onChange({ ...value, login: event.target.value })}
        isOrganisationSelected={isOrganisationSelected}
      />
      <div className={cn.enabledSelect}>
        <HoverElement>
          <AtomSelect
            openByHover={false}
            outlined
            isOrganisationSelected={isOrganisationSelected}
            value={value.enabled}
            options={USERS_ENABLED_OPTIONS}
            handleChange={(enabled) => {
              if (isUsersEnabledFilter(enabled)) onChange({ ...value, enabled })
            }}
            popupClassName={
              isOrganisationSelected ? cn.selectPopupSelected : cn.selectPopup
            }
          />
        </HoverElement>
      </div>
      <AtomDateRangePicker
        className={cn.dateRange}
        fromPlaceholder="Создан с"
        value={value.createdAt}
        onChange={(createdAt) => onChange({ ...value, createdAt })}
        isOrganisationSelected={isOrganisationSelected}
      />
    </div>
  )
}

export default UsersFilters
